import React, { useCallback, useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import CustomSelect from '../../../components/customSelect';
import getEnvironement from '../../../environnement';
import axios from 'axios';
import CustomBackdrop from '../../../components/backdrop';
import { toast } from 'react-toastify';

export default function CommentaireDialog({
  open,
  handleClose,
  reloadData,
  reservation,
  getNotificationData
}) {
  const [commentaires, setCommentaires] = useState([]);
  const [commentaire, setCommentaire] = useState(reservation?.commentaire_id);
  const [commentaireError, setCommentaireError] = useState('');
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const getCommentaires = useCallback(async () => {
    const url = `${getEnvironement().API_URL}/commentaires`;

    await axios.get(url)
      .then((res) => setCommentaires(res.data.commentaires));
  }, [setCommentaires]);

  function getCommentairesItems() {
    const commentairesItem = commentaires.map((item) => {
      return {id: item.id, label: item.commentaire, value: item.id}
    });
    commentairesItem.unshift({id: 0, label: 'Aucun', value: ''});

    return commentairesItem;
  }

  async function editCommentaire() {
    const url = `${getEnvironement().API_URL}/reservations/${reservation.id}`;
    const data = {
      edit: 'commentaire',
      editedData: commentaire
    };
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    handleClose();
    setOpenBackdrop(true);
    await axios.put(url, data, config)
      .then(() => setTimeout(() => setOpenBackdrop(false), 1000))
      .then(() => reloadData())
      .then(() => getNotificationData())
      .then(() => toast.success(`Le commentaire de la demande ${reservation?.numero_demande} a bien été modifié`))
      .catch((err) => {
        setOpenBackdrop(false);
      });
  }

  useEffect(() => {
    getCommentaires();
  }, [getCommentaires]);

  useEffect(() => {
    if (open) {
      setCommentaire(reservation?.commentaire_id);
    }
  }, [reservation?.commentaire_id, open]);

  return (
    <>
      <CustomBackdrop open={openBackdrop} setOpen={setOpenBackdrop} />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{paddingBottom: '0px'}}
      >
        <DialogTitle id="alert-dialog-title">
          <p className='text-2xl sm:text-3xl font-medium font-inter mt-5'>Demande numéro : {reservation?.numero_demande}</p>
          
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <CustomSelect
              items={getCommentairesItems()}
              placeholder='Commentaire'
              value={commentaire}
              setValue={setCommentaire}
              isError={commentaireError !== ''}
              error={commentaireError}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className='flex justify-between px-5 w-full gap-5'>
            <div
              className='group rounded-[20px] py-2 sm:py-3 mb-5 cursor-pointer bg-primary hover:bg-primaryDark w-full'
              onClick={handleClose}
            >
              <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>Annuler</p>
            </div>
            <div
              className='group rounded-[20px] py-2 sm:py-3 mb-5 cursor-pointer bg-primary hover:bg-primaryDark w-full'
              onClick={editCommentaire}
            >
              <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>Confirmer</p>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
